import './picture.css';

for (const event of ['load', 'error']) {
  document.addEventListener(
    event,
    ({ target }) => {
      if (target instanceof HTMLImageElement) {
        target.classList.add('phxsg-picture--loaded');
      }
    },
    true,
  );
}

document.querySelectorAll('img').forEach((image) => {
  if (image.complete) {
    image.classList.add('phxsg-picture--loaded');
  }
});
